export const mapListToOptions = (data) => {
  return (
    data?.data?.list?.map((item) => ({
      label: item?.code + "-" + item?.name, // e.g. "C001 Customer A"
      value: item?.id, // e.g. 123
    })) || []
  );
};
